
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { LandingLayout } from '@/components/layouts/LandingLayout';
import { TranslationProvider } from '@/context/translation';
import { createNonLocalizedPageGetServerSidePropsWithTranslations, type NonLocalizedPageWithTranslationsProps, } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const JewelryLanding = dynamic(async () => await import('@/templates/Landing/Jewelry/JewelryLanding'), {
    loading: LoaderScreen,
});
const index: React.FC<NonLocalizedPageWithTranslationsProps> = ({ locale, translations, }) => {
    return (<TranslationProvider locale={locale} translations={translations}>
			<LandingLayout title='AI Tools for Stunning Jewelry Product Photography | Lift' description='Boost jewelry sales with Lift’s AI-powered photography tools. Easily create stunning, polished product images for marketplaces, social media, and your website — no studio or editing skills required.' ogTitle='Create High-Quality Jewelry Images in Seconds with Lift AI' ogDescription='With Lift, generate high-converting jewelry images in just a few clicks. Highlight fine details, remove backgrounds instantly, and showcase your products in their best light — all powered by AI.'>
				<JewelryLanding />
			</LandingLayout>
		</TranslationProvider>);
};
export default index;
const getServerSideProps = createNonLocalizedPageGetServerSidePropsWithTranslations('/for-businesses/jewelery-photography', 'jewelery-photography');

    async function __Next_Translate__getServerSideProps__1a1a20bb8c9__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/for-businesses/jewelery-photography/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bb8c9__ as getServerSideProps }
  